import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsWarehouseInfoTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['warehouseInfo']> = {
  zh: {
    errorLoadFailed: '加载仓库信息失败，请稍后重试',
    addressTitle: '海外仓地址',
    labelContact: '联系人',
    defaultContactName: '海海快递',
    labelPhone: '电话',
    labelState: '州',
    labelCity: '城市',
    labelAddress: '地址',
    labelZipcode: '邮编',
    appealMaterialsTitle: '电商平台申诉材料',
    appealMaterialsDescription: '当你的店铺被平台限制时，我们可以提供以下资质供你申诉使用。',
    actionContactService: '联系海海客服',
    appealMaterialLicense: '海外仓营业执照',
    appealMaterialLease: '海外仓租赁合同',
    appealMaterialUtilityBill: '海外仓能源或市政账单',
    appealMaterialMedia: '海外仓图片和视频',
    lockedTitle: '获得海外仓地址',
    lockedDescription: '获得美西、美东3个海外仓的详细地址，用于平台开店、商品发货和接收退货。可申请水电账单、租赁合同等资质文件用于店铺认证和申诉。',
    lockedFeature1: '3个美国仓库，覆盖美西美东',
    lockedFeature2: '完整的地址、联系人、电话信息',
    lockedFeature3: '可申请水电账单等资质材料',
    lockedFeature4: '适用于主流电商平台开店',
    actionOpenAccount: '立即开户',
    actionContact: '联系客服',
  },
  en: {
    errorLoadFailed: 'Failed to load warehouse information. Please try again later.',
    addressTitle: 'Warehouse address',
    labelContact: 'Contact',
    defaultContactName: 'SSEEAA',
    labelPhone: 'Phone',
    labelState: 'State',
    labelCity: 'City',
    labelAddress: 'Address',
    labelZipcode: 'ZIP code',
    appealMaterialsTitle: 'Platform appeal materials',
    appealMaterialsDescription: 'If your store is restricted by a platform, we can provide the following supporting documents for appeals.',
    actionContactService: 'Contact SSEEAA support',
    appealMaterialLicense: 'Warehouse business license',
    appealMaterialLease: 'Warehouse lease agreement',
    appealMaterialUtilityBill: 'Utility or municipal bill',
    appealMaterialMedia: 'Warehouse photos and videos',
    lockedTitle: 'Get warehouse addresses',
    lockedDescription: 'Access detailed addresses for 3 US warehouses across West and East regions for store setup, shipments, and returns. Qualification docs can also be requested for verification and appeals.',
    lockedFeature1: '3 US warehouses across West and East',
    lockedFeature2: 'Complete address, contact, and phone details',
    lockedFeature3: 'Support for utility bill and other qualification docs',
    lockedFeature4: 'Suitable for mainstream e-commerce platforms',
    actionOpenAccount: 'Open account',
    actionContact: 'Contact support',
  },
};
